<template>

  <!-- Breadcrumb -->
  <div class="subtitle-container">
    <span class="breadcrumb">Introdução</span>
  </div>

  <!-- Page Title -->
  <div class="title-container">
    <h2 class="primary-title">Auto-diagnóstico em matérias de descarbonização</h2>
  </div>

  <!-- Content -->
  <div class="introduction">
    <p>
      No âmbito da aprovação da sua candidatura PRR, a APQuímica iniciou um
      projeto de dois anos para a construção do Roteiro de Neutralidade
      Carbónica da Indústria Química Portuguesa 2050 (“RNCIQ PT 2050”), com o
      apoio da EY.
    </p>
    <p>&nbsp;</p>
    <p>
      Este projeto, que se enquadra no pilar estratégico da Sustentabilidade
      preconizado pela APQuímica, pretende desenhar um conjunto de cenários de
      descarbonização para o Setor da Indústria Química e da Refinação
      nacionais.
    </p>
    <p>&nbsp;</p>
    <p>
      O RNCIQ PT 2050 possibilitará enquadrar e dar visibilidade aos vários
      projetos e iniciativas de descarbonização em curso no Setor em Portugal, e
      também permitirá:
    </p>
    <p>&nbsp;</p>
    <ul>
      <li>Apresentar a perspetiva do Setor, identificar barreiras e suportar as
        interações da APQuímica, dos seus associados e restantes empresas do
        Setor com as autoridades públicas nacionais e europeias;
      </li>

      <li>Garantir a integração do real contexto do Setor no processo de revisão
        do Roteiro Nacional para a Neutralidade Carbónica 2050;
      </li>

      <li>Criar a base para promover ligações concretas a outros setores /
        projetos (promovidos por empresas e entidades do sistema científico),
        com os quais as empresas industriais associadas da APQuímica e
        restantes empresas do Setor possam ter sinergias e interesse em
        iniciar e/ou aprofundar colaborações;
      </li>

      <li>Contribuir para os processos de discussão e decisão a nível europeu
        relacionados com a descarbonização do Setor.
      </li>
    </ul>

    <p>&nbsp;</p>
    <p>
      Neste sentido é disponibilizada às empresas uma ferramenta de
      autodiagnóstico que permita entender o seu grau de maturidade em matérias
      climáticas e descarbonização, através do preenchimento do questionário que
      se segue. A sua interação com a ferramenta permitirá uma reflexão sobre a
      estratégia de descarbonização da sua empresa.
    </p>

    <p>&nbsp;</p>
    <p>O questionário é composto pelos seguintes capítulos:</p>

    <p>&nbsp;</p>
    <div class="container text-center">
      <div class="row">
        <div
          v-for="sectionInfo in sections"
          :key="sectionInfo.section_Id"
          class="col sections"
        >
          <div class="sections-icon">
            <font-awesome-icon
              class="fa-3x"
              :icon="['fas', sectionInfo.section_Icon]"
            />
          </div>
          <div class="sections-label">
            <span>{{ sectionInfo.section_Desc }}</span>
          </div>
        </div>
      </div>
    </div>

    <p>&nbsp;</p>
    <p>
      Para esclarecimento de dúvidas ou informações adicionais, poderá
      contactar-nos diretamente através dos seguintes endereços:
    </p>
    <p>&nbsp;</p>
    <ul>
      <li>Eduardo Seduvem (Eduardo.Seduvem@pt.ey.com)</li>
      <li>Sofia Mendes Ferreira (sofia.mendes.ferreira@parthenon.ey.com)</li>
    </ul>
  </div>

  <!-- Avançar -->
  <div class="button-container-center">
    <button class="primary-button button button-fill" @click="navigateToNextPage">
      <span>Iniciar</span>
    </button>
  </div>

  <!-- End content -->
</template>

<script>
export default {
  // Receives from the parent component:
  props: [
    'sections', // Dictionary of unique sections {id:[description,logo]}
  ],

  methods: {
    // go to the register page
    navigateToNextPage() {
      this.$router.push('/register');
      this.scrollToTop();
    },
    // method to scroll to top of the page
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>
